import { Component } from '@angular/core';
import { UserBankService } from './../../services/userbank.service';
import { LoaddingService } from './../../providers/loadding.service';
import { StorageService } from './../../providers/storage.service';
import { PageDefault } from './../../pages/PageDefault';
import { ModalController, ViewController } from 'ionic-angular';
import { AddUserBank } from './adduserbank';
import { AlertService } from '../../providers/alert.service';
import { RechargeService } from '../../services/recharge.service';

/*
    用户银行
    TQQ 2017-01-03
*/
@Component({
    selector: "userbank-list",
    templateUrl: "userbanklist.html",
    providers: [UserBankService]
})
export class UserBankList {
    usdtTimer;
    constructor(
        private userbank: UserBankService,
        private loadding: LoaddingService,
        private storage: StorageService,
        private modalCtrl: ModalController,
        private alert: AlertService,
        private viewCtrl: ViewController,
        private rechargeService: RechargeService) {
        // this.usdtTimer = setInterval(()=>{
        //     this.USDTOpen();
        //   },5000)
    }

    modelList = [];
    isHave = true;
    uBankInput = new UserBankInput();
    excludeTracks = [];
    load;
    isUSDTBank;
    ionViewDidLoad() {
        this.USDTOpen();
        this.load = this.loadding.showLoding();
        this.getUserBanks(this.uBankInput).then(s => {
            this.loadding.closeLoading(this.load);
        });
        // this.usdtTimer = setInterval(() => {
        //     this.USDTOpen();
        // }, 5000)
    }

    ionViewWillLeave() {
        clearInterval(this.usdtTimer);
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    //下拉重新加载
    //TQQ 2017-01-03
    doRefresh(refresher) {
        this.uBankInput.pageIndex = 1;
        this.getUserBanks(this.uBankInput).then(s => {
            refresher.complete();
        });
    }

    //添加用户银行
    //TQQ 2017-01-03
    addBank(bankType?: string) {
        let modal = this.modalCtrl.create(AddUserBank, { exclude: this.excludeTracks, bankType: bankType });
        modal.present();
        modal.onWillDismiss((data) => {
            if (data != undefined && data.Result) {
                this.uBankInput.pageIndex = 1;
                this.getUserBanks(this.uBankInput);
            }
        });

    }

    USDTOpen() {
        this.rechargeService.getUsdtSetting().then(s => {
            if (s.Parameter2.IsOpen) {
                this.isUSDTBank = true;

            } else {
                this.isUSDTBank = false;
            }
        })
    }

    //获取用户银行列表
    //TQQ 2017-01-03
    getUserBanks(obj) {
        return this.userbank.getUserBanks(obj.pageIndex, obj.pageSize).then(s => {
            if (obj.pageIndex == 1) {
                this.modelList = [];
                this.modelList = s;
            } else {
                this.modelList = this.modelList.concat(s);
            }
            if (this.modelList == null || this.modelList.length < 1) {
                this.isHave = false;
            } else {
                this.isHave = true;
            }
        }).catch(c => {
            this.loadding.closeLoading(this.load);
        });
    }

    //设为默认银行
    //TQQ 2017-01-03
    setDefaultBank(bankid) {
        let load = this.loadding.showLoding();
        this.userbank.setDefaultBank(bankid).then(s => {
            if (s.Result) {
                this.getUserBanks(this.uBankInput);
            } else {
                this.alert.showAlert(s.Error);
            }
            this.loadding.closeLoading(load);
        }).catch(c => {
            this.loadding.closeLoading(load);
        });
    }

    //页面返回
    //chen 2017-01-19
    close() {
        this.viewCtrl.dismiss();
    }
}

export class UserBankInput {
    pageIndex: number = PageDefault.PageIndex();
    pageSize: number = PageDefault.PageSize()
}







// WEBPACK FOOTER //
// ./src/pages/userbanks/userbanklist.ts